'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import AccordionContext from './AccordionContext';
import { AccordionElement } from './elements';
export const Accordion = /*#__PURE__*/React.forwardRef(({
  ariaLabel = '',
  variant = 'inline',
  numbered = false,
  children,
  ...props
}, fRef) => /*#__PURE__*/React.createElement(AccordionContext.Provider, {
  value: {
    variant,
    numbered
  }
}, /*#__PURE__*/React.createElement(AccordionElement, _extends({
  "data-aui": "accordion",
  "aria-label": ariaLabel,
  ref: fRef,
  $variant: variant
}, props), children)));